import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Turno, useAbrirTurnoMutation, useCerrarTurnoMutation } from "src/gql/schema"
import { useProfile } from "src/shared/hooks/useProfile"
import { getNextSchedule } from "src/pages/personal/components/Board/ColumnFooter/ColumnFooter"
import { Column } from "src/pages/personal/components/Board/types"
import { parseTimeString } from "src/shared/helpers/parseTimeString"
import { setTurn } from "src/store/turn/turnSlice"

export type TurnoConHorario = Pick<Turno, "turno_id" | "nombre" | "hora_entrada" | "hora_salida" | "estado">

export interface TurnoActualConHorario {
    turno_id: string
    nombre: string
    hora_entrada: string
    hora_salida: string
}

export interface UseCambiarTurnoParams {
    turnos?: TurnoConHorario[]
    turnoActual?: TurnoActualConHorario | null
    setSuccess: (value: boolean) => void
}

// Cierra el turno actual, abre el siguiente según el horario y marca el corte como exitoso
export const useCambiarTurno = ({ turnos, turnoActual, setSuccess }: UseCambiarTurnoParams) => {
    const dispatch = useDispatch()
    const { hotel_id, usuario_id } = useProfile()
    const [openNextTurno] = useAbrirTurnoMutation()
    const [closeTurno] = useCerrarTurnoMutation()

    const [allCols, setAllCols] = useState<Column[]>([])
    const [column, setColumn] = useState<Column>({} as Column)
    const [pathSuccess, setPathSuccess] = useState<string>("/u")

    useEffect(() => {
        if (allCols.length === 0 || Object.keys(column).length === 0) {
            setAllCols(
                turnos
                    ?.map((t) => ({
                        id: t.turno_id,
                        title: t.nombre,
                        hora_entrada: t.hora_entrada,
                        hora_salida: t.hora_salida,
                        estado: t.estado,
                    }))
                    .sort(
                        (a, b) => parseTimeString(a.hora_entrada).getTime() - parseTimeString(b.hora_entrada).getTime()
                    ) || []
            )

            turnos?.map((t) => {
                if (t.turno_id === turnoActual?.turno_id) {
                    setColumn({
                        id: t.turno_id,
                        title: t.nombre,
                        hora_entrada: t.hora_entrada,
                        hora_salida: t.hora_salida,
                        estado: t.estado,
                    })
                }
            })
        }
    }, [turnos, turnoActual])

    const cambiarTurno = (): void => {
        const nextTurno = getNextSchedule(allCols, column)
        closeTurno({
            variables: {
                cerrar_turno_input: {
                    hotel_id,
                    usuario_id,
                    turno_id: column.id,
                },
            },
        })
            .then(() => {
                openNextTurno({
                    variables: {
                        open_turno_input: {
                            hotel_id,
                            usuario_id,
                            turno_id: nextTurno.id,
                        },
                    },
                }).then(() => {
                    setPathSuccess("/u/personal")
                    setSuccess(true)
                    dispatch(setTurn({ nombre: nextTurno.title, turno_id: nextTurno.id }))
                })
            })
            .catch((e) => {
                console.log("error", e)
            })
    }

    return { cambiarTurno, pathSuccess }
}
